import { render, staticRenderFns } from "./tenants-user-popup.vue?vue&type=template&id=87844404&scoped=true"
import script from "./tenants-user-popup.vue?vue&type=script&lang=js"
export * from "./tenants-user-popup.vue?vue&type=script&lang=js"
import style0 from "./tenants-user-popup.vue?vue&type=style&index=0&id=87844404&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87844404",
  null
  
)

export default component.exports